import { api } from "@ts/core/api";
import { popMessage } from "@ts/core/Popup";

interface SqlLogLine {
    date:string;
    type:string;
    text:string;
};

export class SQLTool {

    public static async backup() : Promise<void> {
        const resp = await api<void>('sqlBackup');
        if( resp ) {
            popMessage('Backup av databasen utfördes');
        }
    }
    public static async viewLog() : Promise<void> {
        
        const resp = await api<Array<SqlLogLine>>('sqlViewLog');
        if( resp ) {
            const form = document.createElement('form');
            form.className = 'log';

            const table = document.createElement('table');
            form.appendChild(table);

            for( let i=0; i < resp.length; i++) {
                const logLine = resp[i];
                const tr = document.createElement('tr');
                tr.innerHTML = `<td>${logLine.date}</td><td>${logLine.type}</td><td>${logLine.text}</td>`;
                table.appendChild(tr);
            }

            form.appendChild( document.createElement('hr'));
            
            const btn = document.createElement('button');
            btn.innerText = 'OK';
            form.appendChild( btn);

            btn.addEventListener('click', (e:Event) => {
                e.preventDefault();
                form.remove();
            });

            document.body.appendChild(form);
            
        }
    }
    public static restore() : void {
        popMessage(
            'Återskapa databasen så här<br><ul><li>cd backend/backup</li><li>php cli-restore.php /home/roland/stralberg/backup/mariadb/stralberg_backup_[datum].sql.gz</li></ul>',
            30);
        // api<void>('sqlRestore')
    }

}
